import React from 'react';
import SuggestedCreditCardView from 'partial/OfferManager/modules/SuggestedCreditCardModuleRedesign/SuggestedCreditCardView';
import { useCreditCardCategories } from './hooks/CreditCardCategories.hooks';
import { SUGGESTED_CREDIT_CARDS } from 'types/morph.pagePosition.constants';

export const SuggestedCreditCardModuleController = props => {
  const { userInfo, creditInfo, offers, eventHandler, modulePosition, config } =
    props;
  const {
    selectedCategory,
    cardCategoriesContainerLoading,
    cardCategoriesOffers,
    onChangeCategory,
    isLoadingChangueCategory,
    containerType,
    CATEGORY_FILTER,
  } = useCreditCardCategories({
    creditInfo,
    userInfo,
    eventHandler,
  });

  const loading = props.globalLoadingFlag || cardCategoriesContainerLoading;

  return (
    <SuggestedCreditCardView
      offers={offers}
      highestApprovalOddsOffers={cardCategoriesOffers}
      eventHandler={eventHandler}
      pagePosition={SUGGESTED_CREDIT_CARDS}
      onChangeCategory={onChangeCategory}
      categoryList={CATEGORY_FILTER}
      selectedCategory={selectedCategory}
      isLoadingChangueCategory={isLoadingChangueCategory}
      loading={loading}
      containerType={containerType}
      modulePosition={modulePosition}
      config={config}
    />
  );
};
